export enum FileAssignment {
	Content = "Content",
	Avatar = "Avatar",
	Thumbnail = "Thumbnail",
	TrailerVideo = "TrailerVideo",
	LargeImage = "LargeImage",
}
